import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import Layout from "@/components/Layout";
import HomePage from "@/pages/Home";
import ForStudentsPage from "@/pages/ForStudents";
import ForBusinessPage from "@/pages/ForBusiness";
import PricingPage from "@/pages/Pricing";
import AuditPage from "@/pages/Audit";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import NotFoundPage from "@/pages/NotFound";

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/for-students" element={<ForStudentsPage />} />
              <Route path="/for-business" element={<ForBusinessPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/audit" element={<AuditPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Legacy route redirects (site was previously deployed with old routes) */}
              <Route path="/learn" element={<Navigate to="/for-students" replace />} />
              <Route path="/work" element={<Navigate to="/for-business" replace />} />
              <Route path="/explore" element={<Navigate to="/about" replace />} />
              <Route path="/tools" element={<Navigate to="/for-business" replace />} />
              <Route path="/clarity-check" element={<Navigate to="/audit" replace />} />

              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </div>
    </I18nProvider>
  );
}

export default App;
